/* QUINCHIA V14. Progressive enhancement; native Shopify forms remain the fallback. */
(() => {
  'use strict';
  const configNode = document.getElementById('sf-config');
  let config = {};
  try { config = JSON.parse(configNode?.textContent || '{}'); } catch (_) {}
  const rootURL = window.Shopify?.routes?.root || config.root || '/';
  const root = rootURL.endsWith('/') ? rootURL : rootURL + '/';
  const routes = { add: config.add || root + 'cart/add.js', cart: config.cart || root + 'cart', update: root + 'cart/update.js', cartJSON: root + 'cart.js' };
  const toInteger = (value, fallback) => Number.isFinite(Number(value)) ? Math.trunc(Number(value)) : fallback;
  const quantityValue = (value, min = 1, max = null, increment = 1) => {
    min = Math.max(0, toInteger(min, 1)); increment = Math.max(1, toInteger(increment, 1));
    let normalized = Math.max(min, toInteger(value, min));
    normalized = min + Math.floor((normalized - min) / increment) * increment;
    if (max !== null && max !== '' && Number.isFinite(Number(max))) {
      const bound = min + Math.floor((Number(max) - min) / increment) * increment;
      normalized = Math.min(normalized, Math.max(min, bound));
    }
    return normalized;
  };
  const updateCount = count => {
    document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = String(count); });
    document.querySelectorAll('[data-cart-link]').forEach(el => { el.setAttribute('aria-label', 'Bolsa: ' + count + ' artículos'); });
  };
  const request = async (url, options = {}) => {
    let response;
    try { response = await fetch(url, { credentials: 'same-origin', ...options, headers: { Accept: 'application/json', ...options.headers } }); }
    catch (_) { throw new Error('La conexión se interrumpió. Revisa tu bolsa antes de volver a intentarlo.'); }
    let data;
    try { data = await response.json(); } catch (_) { throw new Error('No pudimos confirmar la respuesta. Revisa tu bolsa antes de volver a intentarlo.'); }
    if (!response.ok || data.status >= 400) throw new Error(typeof data.description === 'string' ? data.description : typeof data.message === 'string' ? data.message : 'No pudimos completar el cambio. Revisa tu selección.');
    return data;
  };
  const announce = message => {
    const toast = document.querySelector('[data-sf-toast]');
    if (!toast) return;
    toast.textContent = message; toast.hidden = false;
    clearTimeout(announce.timer);
    announce.timer = setTimeout(() => { toast.hidden = true; }, 4500);
  };
  window.SAM = { config, routes, quantityValue, updateCount, request, announce };

  document.addEventListener('click', event => {
    const stepButton = event.target.closest('[data-quantity-step]');
    if (stepButton && !stepButton.disabled) {
      const field = stepButton.closest('[data-quantity-control]')?.querySelector('input');
      if (!field || field.disabled) return;
      const step = Number(field.step) || 1;
      const next = quantityValue(Number(field.value) + Number(stepButton.dataset.quantityStep) * step, field.min || 1, field.max || null, step);
      if (String(next) !== field.value) { field.value = next; field.dispatchEvent(new Event('change', { bubbles: true })); }
    }
    const close = event.target.closest('[data-sf-close]');
    if (close) {
      const details = close.closest('details');
      if (details) { details.open = false; details.querySelector('summary')?.focus(); }
    }
    const navLink = event.target.closest('.sf-menu-panel a');
    if (navLink) {
      const details = navLink.closest('details');
      if (details) { details.open = false; document.body.classList.remove('sf-scroll-locked'); }
    }
  });

  document.addEventListener('keydown', event => {
    const open = document.querySelector('[data-sf-overlay][open]');
    if (event.key === 'Escape') {
      document.querySelectorAll('details[open].sf-nav-submenu').forEach(el => { el.open = false; });
      if (open) { open.open = false; open.querySelector('summary')?.focus(); }
      return;
    }
    if (event.key !== 'Tab' || !open) return;
    const focusable = [...open.querySelectorAll('summary,a[href],button:not([disabled]),input:not([type=hidden]),select,textarea')].filter(el => el.getClientRects().length);
    const first = focusable[0], last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
  });

  const bound = new WeakSet();

  const initializeVisualMotion = (scope = document) => {
    const revealNodes = [...scope.querySelectorAll('[data-sf-reveal]')].filter(node => !bound.has(node));
    revealNodes.forEach(node => bound.add(node));
    if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      initializeVisualMotion.io = initializeVisualMotion.io || new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
      revealNodes.forEach(node => initializeVisualMotion.io.observe(node));
    } else revealNodes.forEach(node => node.classList.add('is-visible'));

    if (!window.matchMedia('(pointer:fine)').matches || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    scope.querySelectorAll('[data-sf-card]').forEach(card => {
      if (bound.has(card)) return; bound.add(card);
      card.addEventListener('pointermove', event => {
        const rect = card.getBoundingClientRect();
        card.style.setProperty('--sf-x', `${event.clientX - rect.left}px`);
        card.style.setProperty('--sf-y', `${event.clientY - rect.top}px`);
      }, { passive: true });
    });
    scope.querySelectorAll('[data-sf-magnetic]').forEach(button => {
      if (bound.has(button)) return; bound.add(button);
      button.addEventListener('pointermove', event => {
        const rect = button.getBoundingClientRect();
        const dx = ((event.clientX - rect.left) / rect.width - 0.5) * 6;
        const dy = ((event.clientY - rect.top) / rect.height - 0.5) * 5;
        button.style.transform = `translate(${dx}px, ${dy}px)`;
      }, { passive: true });
      button.addEventListener('pointerleave', () => { button.style.transform = ''; }, { passive: true });
    });
  };

  const initialize = scope => {
    scope.querySelectorAll('[data-sf-overlay]').forEach(details => {
      if (bound.has(details)) return; bound.add(details);
      details.addEventListener('toggle', () => {
        if (details.open) {
          document.querySelectorAll('[data-sf-overlay][open]').forEach(other => { if (other !== details) other.open = false; });
          details.querySelector('input[type=search]')?.focus();
        }
        document.body.classList.toggle('sf-scroll-locked', Boolean(document.querySelector('[data-sf-overlay][open]')));
      });
    });
    scope.querySelectorAll('[data-sf-sort]').forEach(select => {
      if (bound.has(select)) return; bound.add(select);
      select.addEventListener('change', () => { if (select.form?.reportValidity()) select.form.requestSubmit(); });
    });
    scope.querySelectorAll('[data-sf-cart]').forEach(initializeCart);
  };

  function initializeCart(cartRoot) {
    const form = cartRoot.querySelector('form');
    if (!form || bound.has(form)) return; bound.add(form);
    let busy = false;
    const status = cartRoot.querySelector('[data-cart-status]');
    const setBusy = value => {
      busy = value; form.setAttribute('aria-busy', String(value));
      form.querySelectorAll('button,input,textarea').forEach(el => { el.disabled = value; });
      cartRoot.querySelectorAll('[data-cart-remove]').forEach(el => { el.setAttribute('aria-disabled', String(value)); });
    };
    const changeCart = async (removedKey = null, focusKey = null) => {
      if (busy) return;
      const updates = {};
      form.querySelectorAll('[data-cart-quantity]').forEach(input => {
        input.value = quantityValue(input.value, input.min || 1, input.max || null, input.step || 1);
        updates[input.dataset.key] = Number(input.value);
      });
      if (removedKey) updates[removedKey] = 0;
      const payload = { updates, sections: [cartRoot.dataset.sectionId], sections_url: window.location.pathname, note: form.querySelector('[name=note]')?.value || '' };

      // Shopify 2026 standard storefront cart event for custom AJAX updates.
      const SE = window.StandardEvents;
      let cartEventDeferred = null;
      if (SE?.CartLinesUpdateEvent) {
        try {
          const eventLines = removedKey
            ? [{ id: String(removedKey), quantity: 0 }]
            : [...form.querySelectorAll('[data-cart-quantity]')].map(input => ({ id: String(input.dataset.key), quantity: Number(input.value) }));
          cartEventDeferred = SE.CartLinesUpdateEvent.createPromise();
          cartRoot.dispatchEvent(new SE.CartLinesUpdateEvent({
            action: removedKey ? 'remove' : 'update',
            context: 'cart',
            lines: eventLines,
            promise: cartEventDeferred.promise,
          }));
        } catch (_) { cartEventDeferred = null; }
      }

      status.textContent = 'Actualizando tu bolsa…'; status.classList.remove('sf-error');
      setBusy(true);
      try {
        const data = await request(routes.update, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) });
        updateCount(data.item_count);
        if (cartEventDeferred && SE?.CartLinesUpdateEvent?.createCartFromAjaxResponse) {
          cartEventDeferred.resolve({ cart: SE.CartLinesUpdateEvent.createCartFromAjaxResponse(data) });
          cartEventDeferred = null;
        }
        const html = data.sections?.[cartRoot.dataset.sectionId];
        if (!html) { window.location.reload(); return; }
        const template = document.createElement('template'); template.innerHTML = html;
        const replacement = template.content.querySelector('[data-sf-cart]');
        if (!replacement) { window.location.reload(); return; }
        cartRoot.replaceWith(replacement); initializeCart(replacement);
        if (focusKey) {
          const field = [...replacement.querySelectorAll('[data-cart-quantity]')].find(el => el.dataset.key === focusKey);
          if (field) field.focus({ preventScroll: true });
        }
        const freshStatus = replacement.querySelector('[data-cart-status]');
        if (freshStatus) freshStatus.textContent = 'Bolsa actualizada.';
        else announce('Tu bolsa está vacía.');
      } catch (error) {
        if (cartEventDeferred) {
          cartEventDeferred.reject(error);
          cartEventDeferred = null;
          try {
            if (SE?.CartErrorEvent) cartRoot.dispatchEvent(new SE.CartErrorEvent({ error: error.message || 'Cart update failed', code: 'SERVICE_UNAVAILABLE' }));
          } catch (_) {}
        }
        form.querySelectorAll('[data-cart-quantity]').forEach(input => { input.value = input.dataset.originalQuantity; });
        status.textContent = error.message || 'No pudimos confirmar el cambio. Recarga tu bolsa para comprobarlo.'; status.classList.add('sf-error');
      } finally { if (cartRoot.isConnected) setBusy(false); }
    };
    form.addEventListener('change', event => { if (event.target.matches('[data-cart-quantity]')) changeCart(null, event.target.dataset.key); });
    form.addEventListener('submit', event => {
      if (busy) { event.preventDefault(); return; }
      if (event.submitter?.name === 'checkout') return;
      event.preventDefault(); changeCart();
    });
    form.addEventListener('click', event => {
      const link = event.target.closest('[data-cart-remove]');
      if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      event.preventDefault(); if (!busy) changeCart(link.closest('[data-cart-line]').dataset.cartKey);
    });
  }

  const initializeHomeNavPill = () => {
    if (!document.body.classList.contains('template-index')) return;
    const community = document.getElementById('comunidad');
    const communityLink = document.querySelector('.sf-desktop-nav [data-sf-nav-link="comunidad"]');
    const homeLink = document.querySelector('.sf-desktop-nav [data-sf-nav-link="inicio"]');
    if (!community || !communityLink || !homeLink || communityLink.dataset.sfSectionBound) return;
    communityLink.dataset.sfSectionBound = 'true';
    const setCommunity = active => {
      communityLink.classList.toggle('is-section-active', active);
      if (active) homeLink.removeAttribute('aria-current');
      else if (location.hash !== '#comunidad') homeLink.setAttribute('aria-current','page');
    };
    const syncHash = () => setCommunity(location.hash === '#comunidad');
    communityLink.addEventListener('click', () => setCommunity(true));
    homeLink.addEventListener('click', () => setCommunity(false));
    window.addEventListener('hashchange', syncHash);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting && entry.intersectionRatio > .28) setCommunity(true);
          else if (!entry.isIntersecting && location.hash !== '#comunidad') setCommunity(false);
        });
      }, { threshold:[0,.28,.5], rootMargin:'-18% 0px -34% 0px' }).observe(community);
    }
    syncHash();
  };

  const initializeHeroDepth = () => {
    const hero = document.querySelector('.template-index .sf-hero');
    if (!hero || hero.dataset.heroDepthBound || !window.matchMedia('(pointer:fine)').matches || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    hero.dataset.heroDepthBound = 'true';
    const setVars = (x, y) => {
      hero.style.setProperty('--sf-hero-mx', `${x.toFixed(2)}px`);
      hero.style.setProperty('--sf-hero-my', `${y.toFixed(2)}px`);
    };
    hero.addEventListener('pointermove', event => {
      const rect = hero.getBoundingClientRect();
      const px = (event.clientX - rect.left) / rect.width - 0.5;
      const py = (event.clientY - rect.top) / rect.height - 0.5;
      hero.classList.add('is-hovering');
      setVars(px * 18, py * 14);
    }, { passive: true });
    hero.addEventListener('pointerleave', () => {
      hero.classList.remove('is-hovering');
      setVars(0, 0);
    }, { passive: true });
  };

  initialize(document);
  initializeVisualMotion(document);
  initializeHomeNavPill();
  initializeHeroDepth();
  document.addEventListener('shopify:section:load', event => { initialize(event.target); initializeVisualMotion(event.target); initializeHeroDepth(); });
  document.addEventListener('shopify:section:unload', () => { document.body.classList.remove('sf-scroll-locked'); });
})();
